import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";
import { Log } from "../../../../../types/Logs";

export default function TermsReminderSent(props: Partial<Log>) {
  const { employeeId, employee } = props;
  const { t } = useTranslation();

  const employeeName = useMemo(
    () => employee ?? employeeId ?? "",
    [employee, employeeId]
  );

  return useMemo(
    () =>
      replaceByElement(t("log.terms_reminder_sent_to"), "{name}", employeeName),
    [employeeName, t]
  );
}
